let BTUploader
if (typeof document !== 'undefined') {
 BTUploader = require('brighttalk-uploader')
}

const featureImage = {
  submit: (webcastId, file) => {

    return new Promise<void>((resolve, reject) => {

      const uploader = BTUploader.initialise({
        'browse_button': document.createElement('div'),
        uploadOnly: true
      })

      uploader.on(BTUploader.FILE_UPLOADED, () => {

        resolve()

      })

      uploader.on(BTUploader.ERROR, (e) => {

        reject(e)

      })

      uploader.addFile(file)
      uploader.start({
        type: 'featureimage',
        target: {
          id: webcastId,
          type: 'communication'
        },
        region: 'US West (California)'
      })

    })

  }
}

export default featureImage
